function ButtonGray(props) {
  return (
    <div className="button-grey">
      <button type="button" className={`button-gray__button ${props.className}`}>{props.label}</button>
    </div>
  )
}

export default ButtonGray